package br.com.texeratx.boardgametimeapp.data.model.expansion

import kotlinx.serialization.Serializable

@Serializable
data class CreateExpansionRequest(
    val name: String,
    val gameId: Long,
    val imageUrl: String? = null,
    val bggUrl: String? = null,
    val status: Int = 1
)
